import { Suspense } from "react";
import {
  Button,
  Skeleton,
  Stack,
  styled,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { NavLink } from "components/navigation/NavLink";
import { useLayoutContext } from "../hooks/routingHooks";

import { SelectedLayers } from "../components/layers/SelectedLayers";
import { PaddedPaper } from "../components/surfaces/PaddedPaper";
import { ErrorBoundary } from "react-error-boundary";
import { LayersFallback } from "../components/boundary/LayersFallBack";
import { Spacer } from "components/layout/Spacer";
import { RemoveSelectionButton } from "components/button/RemoveSelectionButton";

export function LayersPage() {
  const { t } = useTranslation();
  const {
    config,
    settings: { layerProperties },
  } = useLayoutContext();

  return render();

  function render() {
    return (
      <StyledPaddedPaper elevation={0}>
        <Toolbar variant="dense" className="title-toolbar">
          <Typography variant="subtitle2">{t("label.mapLayers")}</Typography>
          <Spacer />
          <RemoveSelectionButton
            config={config}
            layerProperties={layerProperties}
          />
        </Toolbar>
        {config && (
          <ErrorBoundary FallbackComponent={LayersFallback}>
            <Suspense fallback={<LayersSkeleton />}>
              <SelectedLayers
                className="full-height"
                config={config}
                layerProperties={layerProperties}
              />
            </Suspense>
          </ErrorBoundary>
        )}

        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="align-bottom"
          component={NavLink}
          to="add"
        >
          {t("label.addALayer")}
        </Button>
      </StyledPaddedPaper>
    );
  }
}

function LayersSkeleton() {
  return (
    <Stack spacing={-1}>
      <Skeleton variant="text" height={64} />
      <Skeleton variant="text" height={64} />
      <Skeleton variant="text" height={64} />
    </Stack>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;

  .full-height {
    flex: 1 1 100%;
    overflow-y: auto;
    margin-right: ${({ theme }) => theme.spacing(-2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  }

  .title-toolbar {
    margin: ${({ theme }) => theme.spacing(-2, -2, 0, -2)};
    padding: ${({ theme }) => theme.spacing(2, 2, 0, 2)};

    .MuiTypography-root {
      flex-shrink: 0;
    }
  }
`;
